import { Icon } from '@iconify/react/dist/iconify.js';
import { Circle, Grid } from 'react-feather';

export default [
    {
        id: 'project-team',
        title: 'Project Team',
        icon: <Grid size={20} />,
        children: [
            {
                id: 'department',
                title: 'Departments',
                icon: <Circle size={20} />,
                navLink: '/project-team/department'
            },
            {
                id: 'designation',
                title: 'Designations',
                icon: <Circle size={20} />,
                navLink: '/project-team/designation'
            },
            {
                id: 'team-members',
                title: 'Team Members',
                icon: <Icon icon="bxs:user-badge" />,
                navLink: '/project-team/team-members'
            }
        ]
    }
];
